module.exports = __webpack_public_path__ + "assets/92c0f7519f0cb31a77bcb905f70ae725.svg";